import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges, OnChanges, Renderer2 } from '@angular/core';
import { CommonFilterService } from '../../services/common-filter/common-filter.service';
import { DaterangepickerComponent } from '../daterangepicker/daterangepicker.component';
import { DaterangepickerDirective } from '../daterangepicker/daterangepicker.directive';

import * as moment from 'moment';
import { KeyValue } from '@angular/common';
import { DatePickerComponent } from 'ngx-bootstrap/datepicker/public_api';
//import { setTimeout } from 'timers';

import { DataFilter, FilterOperator, DataType, FilterMetadata } from 'lib/ng-data-table/base';
import { DtMessages, DtMessagesEn } from 'lib/dt-translate';

@Component({
  selector: 'app-common-filter',
  templateUrl: './common-filter.component.html',
  moduleId: module.id,
  styleUrls: ['./common-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CommonFilterComponent implements OnInit, OnChanges {

  //@ViewChildren('cmp') components: QueryList<CustomComponent>;
  displayCalender = false;

  //To be bound in dropdown based on vqt and general rslt type - toggle VQT Timestamp here
  @Input() rsltTypeTS: string = '-1';
  @Input() listenNext: string = 'none';
  timestamps = [
    { value: '0', viewValue: 'Call Timestamp' },
    { value: '1', viewValue: 'VQuad / vMobile Timestamp' },
    { value: '2', viewValue: 'VQT Timestamp' }
  ];
  TSSelected = '1';
  TSOptionSelected = '1';
  //https://stackoverflow.com/questions/51930085/hide-selected-option-in-mat-select
  //TSDisabled = true;
  get filteredTSOptions() {
    //console.log(this.TSSelected)
    if (this.TSSelected == '2') {
      if (this.rsltTypeTS == '-1')
        this.TSOptionSelected = '2';
      else
        this.TSOptionSelected = '1';
    }
    return this.rsltTypeTS == '2' ?
      this.timestamps.filter(timestamp => timestamp.value !== this.rsltTypeTS) :
      this.timestamps;
  }

  @Output() RefreshClicked = new EventEmitter();
  AutoRefSelected = '5';
  //Start = '1';
  AutoRefStop: boolean = true;
  @Output() AutoRefreshInfo = new EventEmitter();

  @Output() EventIDFilter = new EventEmitter();

  selectedTime: any;
  selectedStartDateTime: any;
  selectedEndDateTime: any;
  //@ViewChild('dateStartInput', { static: true }) dateStartInput: ElementRef;
  //@ViewChildren('dateEndInput') dateEndInput: QueryList<ElementRef<HTMLInputElement>>;
  //@ViewChild(DaterangepickerDirective, { static: true }) pickerDirective: DaterangepickerDirective;
  //picker: DaterangepickerComponent;
  ranges: any = {
    'Last 10 Minutes': [moment().subtract(13, 'minutes'), moment(), true],
    'Last Hour': [moment().subtract(1, 'hours'), moment(), false],
    'Last 12 Hours': [moment().subtract(12, 'hours'), moment(), false],
    'Last 24 Hours': [moment().subtract(24, 'hours'), moment(), false],
    Today: [moment().hour(0).minute(0), moment().hour(23).minute(59), false],
    Yesterday: [moment().subtract(1, 'days').hour(0).minute(0), moment().subtract(1, 'days').hour(23).minute(59), false],
    'Last 7 Days': [moment().subtract(6, 'days'), moment(), false],
    //'Last 30 Days': [moment().subtract(29, 'days'), moment(), false],
    //'This Month': [moment().startOf('month'), moment().endOf('month'), false],
    'Last Month': [
      moment()
        .subtract(1, 'month'),
      //.startOf('month'),
      moment(),
      //.subtract(1, 'month')
      //.endOf('month'),
      false
    ],
    'Last 6 Months': [
      moment()
        .subtract(6, 'month'),
      //.startOf('month'),
      moment(),
      //.subtract(6, 'month')
      //.endOf('month'),
      false
    ],
    //'Last Year': [moment().subtract(1, 'years'), moment()],
    //'Search Entire dBase': [moment().subtract(5, 'years'), moment(), false]
    //'Custom range': [moment(), moment(), false],
  };
  // Preserve original property order
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  stringOperators: any[];
  defaultStringMatchMode = FilterOperator.CONTAINS;
  messages: DtMessages = new DtMessagesEn({});
  //done: boolean;
  constructor(private commonFilterService: CommonFilterService, private renderer: Renderer2, private el: ElementRef,) {
    // debugger;
    this.selectedTime = { startDate: moment(), endDate: moment() };
    this.selectedStartDateTime = { startDate: moment(), endDate: moment() };
    this.selectedEndDateTime = { startDate: moment(), endDate: moment() };

    this.stringOperators = [
      { value: FilterOperator.STARTS_WITH, text: this.messages.startsWith },
      { value: FilterOperator.ENDS_WITH, text: this.messages.endsWith },
      { value: FilterOperator.CONTAINS, text: this.messages.contains },
      { value: FilterOperator.NOT_CONTAINS, text: this.messages.notContains },
      { value: FilterOperator.EQUALS, text: this.messages.equals },
      { value: FilterOperator.NOT_EQUAL, text: this.messages.notEqual },
      //{ value: FilterOperator.IS_EMPTY, text: this.messages.isEmpty },
      //{ value: FilterOperator.IS_NOT_EMPTY, text: this.messages.isNotEmpty },
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.commonFilterService.TSType.subscribe(res => {//For setting recently selected value after page changed, see if VQT screen or not to select VQT Timestamp or VQuad timestamp - IMP
      //setTimeout(() => {
      this.rsltTypeTS == '-1' ? this.TSOptionSelected = res.toString() : (res == 2 ? this.TSOptionSelected = '1' : this.TSOptionSelected = res.toString());
      this.TSSelected = res.toString();//value subscribed for querying and sent to  basic
      //this.done = true;
      //}, 0);
    });

    let inputValue = null;
    this.commonFilterService.TSRangeFilter.subscribe(res => inputValue = res.RangeSelected);//set input here
    //console.log(inputValue)
    this.customOrNot = false;
    //debugger
    if (inputValue == 'Custom range') {
      this.customOrNot = true;
      this.commonFilterService.TSBetween.subscribe(res => {
        this.wrongDateRange = false;
        ////https://stackoverflow.com/questions/38251763/moment-js-how-to-convert-date-string-into-date
        if (res != "") {
          this.selectedStartDateTime.startDate = moment(new Date(res.split('^')[0]));
          this.selectedEndDateTime.startDate = moment(new Date(res.split('^')[1]));
        }
        else {
          this.selectedStartDateTime = { startDate: moment().subtract(10, 'minutes') };
          this.selectedEndDateTime = { startDate: moment() };
        }
      });

    }

    this.commonFilterService.mainFilter_ContainsCustDate.subscribe(res => {
      this.disabled = res;      //// set value(true/false) if selected mainfilter has customdate time, so that custome date control is disabled accordingly
      ////this.timeSelDisabled = false;
      //debugger;

    });

    ///// to set custom datetime defined in mainfilter config screen
    this.commonFilterService.mfDateTime.subscribe(res1 => {
      if (res1 != "") {
        ////alert('IN');
        //this.selectedStartDateTime = { startDate: moment(new Date(res1.split(';')[0])) }; //moment(new Date('03/23/2022 14:16:54'));
        //this.selectedEndDateTime = { startDate: moment(new Date(res1.split(';')[1])) };  // moment(new Date('03/27/2022 14:26:54'));        
      }
      else {
        this.commonFilterService.TSBetween.subscribe(res => {
          this.wrongDateRange = false;
          //https://stackoverflow.com/questions/38251763/moment-js-how-to-convert-date-string-into-date
          if (res != "") {
            this.selectedStartDateTime.startDate = moment(new Date(res.split('^')[0]));
            this.selectedEndDateTime.startDate = moment(new Date(res.split('^')[1]));
          }

          if (this.origCustDateTime != "" && !this.disabled) {
            this.selectedStartDateTime.startDate = moment(new Date(this.origCustDateTime.split('^')[0]));
            this.selectedEndDateTime.startDate = moment(new Date(this.origCustDateTime.split('^')[1]));
            this.origCustDateTime = "";
          }
        });
        //this.selectedStartDateTime = { startDate: moment() }; //moment(new Date('2022/03/20 14:16:54'));
        //this.selectedEndDateTime = { startDate: moment() }; //moment(new Date('2022/03/24 14:26:54'));
      }
    }, err => {
      this.selectedStartDateTime = { startDate: moment() };
      this.selectedEndDateTime = { startDate: moment() };
    });

    this.setCommonFilters(inputValue);
    //this.AutoRefreshInfo.emit({ TSSelected: this.TSSelected, AutoRefSelected: 5 * 1000, AutoRefStop: true });//set default selection as auto refresh 5 sec and just stopped
  }

  ngOnInit() {
    //debugger;
    //console.log(this.done)
    this.AutoRefreshInfo.emit({ TSSelected: this.TSSelected, AutoRefSelected: 5 * 1000, AutoRefStop: true });//set default selection as auto refresh 5 sec and just stopped
    //console.log('init')
    //this.picker = this.pickerDirective.picker;
    
  }

  onTSChanged(): void {
    //debugger;
    this.TSSelected = this.TSOptionSelected;//Set new chnaged option value and can be sent to  basic - IMP
    //this.setCommonFilters();
    this.onRefreshClicked(null, null);
  }
  wrongDateRange: boolean;
  origCustDateTime = "";//not needed as controllled the same in load filter comp
  onOKClicked(): void {
    if (this.customOrNot) {
      //this.dateEndInput.first.nativeElement.click();
      //debugger;
      this.wrongDateRange = false;
      ////https://stackoverflow.com/questions/19705003/moment-js-months-difference
      //let monthsDiff = parseInt(this.selectedEndDateTime.startDate.diff(this.selectedStartDateTime.startDate, 'months', true));
      //https://stackoverflow.com/questions/25150570/get-hours-difference-between-two-dates-in-moment-js
      let duration = moment.duration(this.selectedEndDateTime.startDate.diff(this.selectedStartDateTime.startDate));
      let monthsDiff = duration.months();
      let yearsDiff = duration.years();

      if (this.selectedStartDateTime.startDate.diff(this.selectedEndDateTime.startDate) >= 0 || monthsDiff >= 7 || yearsDiff >= 1) {
        if (monthsDiff >= 7 || yearsDiff >= 1) {
          let r = confirm('Searching for data more than 6 months may take longer time..');//alert('Dates selection cannot be more than 6 months');
          if (r == false)
            return;
        }
        else {
          this.wrongDateRange = true;
          return;
        }
      }
      this.onRefreshClicked(null, 'Custom range', true);

      //for (const key in this.ranges) {
      //  if (this.ranges[key]) {
      //    this.ranges[key][2] = false;
      //    if (key == 'Custom range')
      //      this.ranges[key][2] = true;
      //  }
      //}
    }
  }
  onStartDateChanged($event): void {
    //debugger;
    if ($event.startDate != null)
      this.selectedStartDateTime.startDate = $event.startDate;
  }
  onEndDateChanged($event): void {
    //debugger;
    if ($event.startDate != null)
      this.selectedEndDateTime.startDate = $event.startDate;
  }
  disabled: boolean = false;
  //timeSelDisabled: boolean = true;
  startCalendarOpen: boolean;
  endCalendarOpen: boolean;
  notCustomInputValue = 'Last 10 Minutes';
  onRefreshClicked(event, inputValue, okClick?: boolean): void {
    //debugger;
    //console.log(this.notCustomInputValue)
    if (event != null)
      event.preventDefault();
    this.setCommonFilters(inputValue, okClick);
    let TSSelected = this.TSSelected;

    if (inputValue != 'Custom range' || okClick) {
      if (inputValue != 'Custom range' && inputValue != null)
        this.notCustomInputValue = inputValue;
      this.RefreshClicked.emit(TSSelected);
    }
    //if (inputValue == 'Custom range' && !okClick)
    //  this.dateEndInput.first.nativeElement.click();
  }

  setCommonFilters(inputValue, okClick?: boolean) {

    //this.timeSelDisabled = true;
    //this.startDate.format(this.moment.localeData().longDateFormat('lll')) +
    //  this.locale.separator + this.endDate.format(this.moment.localeData().longDateFormat('lll'));
    let startAndEndDates = this.selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + this.selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');//this.dateStartInput.nativeElement.value
    //debugger
    let mfCustDateBool = false;

    if (inputValue != null) {
      if (inputValue == "Custom range") {
        //this.timeSelDisabled = false;
        this.selectedTime.startDate = this.selectedStartDateTime.startDate;
        this.selectedTime.endDate = this.selectedEndDateTime.startDate;
        //let dates = this.selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + this.selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');
        //this.commonFilterService.TSBetween.subscribe(res => dates = res);
        if (okClick == undefined) {
          this.wrongDateRange = false;
          this.commonFilterService.TSBetween.subscribe(res => startAndEndDates = res);
        }
        else {
          startAndEndDates = this.selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + this.selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');
          this.origCustDateTime = this.selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + '^' + this.selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');
        }
      }
      else {
        //if (this.dateStartInput !== undefined || this.dateEndInput !== undefined) {
        //let inputValue = this.dateStartInput.nativeElement.value;
        //if (inputValue.length == 0)//Default/Last selected setting when page loaded / changed to different page
        //{
        //this.commonFilterService.TSRangeFilter.subscribe(res => inputValue = res.RangeSelected);//set input here
        for (const key in this.ranges) {
          if (this.ranges[key]) {
            this.ranges[key][2] = false;

            if (key == inputValue) {

              //// set datetime if selected mainfilter has customdate time, so that custome date control is set accordingly
              this.commonFilterService.mainFilter_ContainsCustDate.subscribe(res => {
                //this.disabled = res;      //// set value(true/false) if selected mainfilter has customdate time, so that custome date control is disabled accordingly
                ////this.timeSelDisabled = false;

                if (res) {
                  ///// set start/end datetime in mainscreen datefilter control as per mainfilter custom datetime if it has any           
                  let selectedTime: any;
                  selectedTime = { startDate: moment(), endDate: moment() };
                  let custDates = selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');//this.dateStartInput.nativeElement.value;
                  this.commonFilterService.mfDateTime.subscribe(resd => custDates = resd);
                  this.commonFilterService.setMFCustDT(custDates.replace('^', ';'));
                  mfCustDateBool = true;
                }
                else {
                  //debugger
                  this.selectedTime.startDate = this.ranges[key][0];
                  this.selectedTime.endDate = this.ranges[key][1];
                  this.selectedStartDateTime = { startDate: moment(), endDate: moment() };
                  this.selectedEndDateTime = { startDate: moment(), endDate: moment() };

                  startAndEndDates = this.selectedTime.startDate.format('MM/DD/YYYY HH:mm:ss') + ' - ' + this.selectedTime.endDate.format('MM/DD/YYYY HH:mm:ss');
                }
              });


              this.ranges[key][2] = true;
            }
          }
        }
      }
      //debugger;
      //if (!this.disabled)
      if (inputValue == "Custom range" || mfCustDateBool)//NEEDED ONLY FOR CUSTOM RANGE
        this.commonFilterService.setProperties(parseInt(this.TSSelected), startAndEndDates);//this.TimeSelected);
      this.setRange(inputValue);
    }
    else
      this.commonFilterService.setProperties(parseInt(this.TSSelected), '');

    this.commonFilterService.GeneralEventIDFilter.subscribe(res => {
      //debugger;
      const filtersWithEventID: FilterMetadata = res;
      let filterExists = false;

      for (const key in filtersWithEventID) {
        filterExists = true;
        if (this.eventIDFilterVal == '') {

          if (filtersWithEventID[key].matchMode.toLowerCase().indexOf('contains') != -1
            && filtersWithEventID[key].value.indexOf('_') == 0 && filtersWithEventID[key].value.lastIndexOf('_') == filtersWithEventID[key].value.length - 1
            && filtersWithEventID[key].value.substring(1, filtersWithEventID[key].value.length - 1).indexOf('_') == -1) {
            let newVal = filtersWithEventID[key].value.substring(1, filtersWithEventID[key].value.length - 1);
            let newMatchMode = filtersWithEventID[key].matchMode.indexOf('not') != -1 ? 'notEqual' : 'equals';
            this.eventIDFilterVal = newVal;
            this.defaultStringMatchMode = FilterOperator[Object.keys(FilterOperator)[Object.values(FilterOperator).indexOf(newMatchMode)]];
          }
          else {
            this.eventIDFilterVal = filtersWithEventID[key].value;
            //https://levelup.gitconnected.com/typescript-enums-look-up-the-name-key-of-a-string-based-enum-member-220f16535770
            this.defaultStringMatchMode = FilterOperator[Object.keys(FilterOperator)[Object.values(FilterOperator).indexOf(filtersWithEventID[key].matchMode)]];
          }
        }
        this.critInputDisabled = false;
        this.resetOrNot = true;
      }

      if (this.resetOrNot && !filterExists) {//When deleted from Synop table
        this.resetOrNot = false;
        this.eventIDFilterVal = "";
        this.defaultStringMatchMode = FilterOperator.CONTAINS;
      }
    });
    //console.log(okClick)
    if (okClick == undefined)
      this.commonFilterService.filter(this.listenNext);//intimates that filters of this component changed
  }

  setRange(inputValue) {
    //console.log(inputValue)
    //this.dateStartInput.nativeElement.value = inputValue;
    //debugger;
    let rangeInfo: any = {
      RangeType: this.setRangeType(inputValue),
      RangeSelected: inputValue,
    }
    //console.log(rangeInfo)
    this.commonFilterService.setRangeFilterData(rangeInfo);
  }
  setRangeType(value) {
    switch (value) {
      case 'Last 10 Minutes':
        return '10min';
      case 'Last Hour':
        return 'hour';
      case 'Last 12 Hours':
        return '12hours';
      case 'Last 24 Hours':
        return '24hours';
      case 'Today':
        return 'today';
      case 'Yesterday':
        return 'yesterday';
      case 'Last 7 Days':
        return '7days';
      case 'Last Month':
        return 'month';
      case 'Last 6 Months':
        return '6months';
      case 'Last Year':
        return 'year';
      case 'Custom range':
        return 'custom';
    }

    return '';
  }
  onAutoRefreshClicked() {
    //debugger;
    this.AutoRefStop = !this.AutoRefStop;
    this.setCommonFilters(null);
    this.AutoRefreshInfo.emit({ AutoRefSelected: parseInt(this.AutoRefSelected) * 1000, AutoRefStop: this.AutoRefStop });
  }

  customOrNot: boolean = false;
  onCustomDatesChange() {
    this.origCustDateTime = "";//reset
    this.customOrNot = !this.customOrNot;
    if (!this.customOrNot && !this.disabled)
      this.onRefreshClicked(null, this.notCustomInputValue);
  }

  eventIDOrNot: boolean = true;
  resetOrNot: boolean = false;
  eventIDFilterVal: string = '';
  onEventIDFilterClick() {
    this.onOKClicked();
    if (this.wrongDateRange)
      return false;
    //this.validateCriteria();
    //if (this.critErrors == true)
    //  return false;

    if (this.eventIDFilterVal.length !== 0) {
      let filters: FilterMetadata = {} as FilterMetadata;
      ////let filtersArray: GeneralFilter[] = [];

      //if (!this.eventIDOrNot) {//clear - not in use
      //  this.eventIDFilterVal = "";
      //  this.commonFilterService.GeneralFilter.subscribe(res => {
      //    if (res) {
      //      //console.log(res)
      //      filters = res;
      //      if (filters["VQuad_CallID"]) {
      //        delete filters["VQuad_CallID"];

      //        //this.commonFilterService.AllGeneralFilter.subscribe(resAll => {
      //        //  if (resAll) {
      //        //    filtersArray = resAll;
      //        //    //https://stackoverflow.com/questions/15287865/remove-array-element-based-on-object-property
      //        //    filtersArray = filtersArray.filter(function (obj) {
      //        //      return obj.ColumnName !== 'VQuad_CallID';
      //        //    });
      //        //  }
      //        //});
      //      }
      //    }
      //  });
      //  //setTimeout(() => {

      //  //}, 2000);
      //  //console.log(filters)
      //  this.commonFilterService.setGeneralFilterData(filters);
      //  //this.commonFilterService.setAllGeneralFilterData(filtersArray);
      //}
      //else
      {//apply
        debugger;
        let value = this.eventIDFilterVal;
        let matchMode = this.defaultStringMatchMode;
        if (this.defaultStringMatchMode.toLowerCase().indexOf('equal') != -1 && this.eventIDFilterVal.indexOf('_') == -1) {
          value = "_" + value + "_";//dynamically changing Event filtering for either Cal ID or Device ID when equals or not equals operator selected
          matchMode = FilterOperator.CONTAINS;
          if (this.defaultStringMatchMode.toLowerCase().indexOf('not') != -1)
            matchMode = FilterOperator.NOT_CONTAINS;
        }
        let valueTo = null;
        let type = DataType.String;
        let rsltType = "";
        let title = 'VQuad Event ID';
        filters["VQuad_CallID"] = { value, matchMode, valueTo, type, rsltType, title };
        this.resetOrNot = true;
        this.commonFilterService.setGeneralEventIDFilterData(filters);
        //this.commonFilterService.setAllGeneralFilterData(filtersArray);
      }
      //this.eventIDFilterVal = "";
      //this.defaultStringMatchMode = FilterOperator.CONTAINS;
      ////this.eventIDOrNot = !this.eventIDOrNot;
      //this.critInputDisabled = false;

      this.EventIDFilter.emit();//send refresh command here to all main screens
    }
    else
      this.commonFilterService.filter(this.listenNext);//intimates that filters of this component changed with only dates chaged
  }

  onResetClick() {
    this.resetOrNot = false;
    this.eventIDFilterVal = "";
    this.defaultStringMatchMode = FilterOperator.CONTAINS;
    this.critInputDisabled = false;

    this.commonFilterService.setGeneralEventIDFilterData({});
    //this.commonFilterService.filter(this.listenNext);//intimates that filters of this component changed
    this.EventIDFilter.emit();//send refresh command here to all main screens
  }

  critInputDisabled = false;
  onModeChange() {
    this.critInputDisabled = false;
    if (this.defaultStringMatchMode == FilterOperator.IS_EMPTY || this.defaultStringMatchMode == FilterOperator.IS_NOT_EMPTY) {
      this.critInputDisabled = true;
      this.critErrors = false;
    }
    //else
    //  this.eventIDFilterVal = "";//reset
  }

  critErrors: boolean = false;
  critErrorDesc = "*Required";
  validateCriteria() {
    this.critErrors = false;
    //debugger
    //when input empty
    if (this.eventIDFilterVal.length === 0 && this.critInputDisabled == false) {
      this.critErrors = true;
    }
  }

  OpenHelp() {

    let pdfFilePath = '/Webviewer/assets/DowloadedScripts/GoogleMapHelp.html';  //// '/Webviewer/assets/images/ITS/ITSHelp.pdf?v=6.4.20';

    const windowFeatures = 'menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes,height = ' + screen.height * .66 + ',width=' + screen.width * .66;
    // Open the popup window
    //const popupWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    const popupWindow = window.open('', '_blank', windowFeatures);

    popupWindow.document.open();
    popupWindow.document.write(`
				<html>
					<head>
						<title>Event ID Filter HELP</title>
						
            <body onload="">

<div>
  <section>
    <h4>Equals:</h4>

    Usage: This feature is used to filter and select exact values of the Call ID, Device ID, or Event ID within a specified time range.<br />
    <br/>Example:
<p style="padding-left:10px;">
Event ID: O_5GPOLQATEST_BTPhone1_20231027150155
<br/>If user provide the Event ID as 'O_5GPOLQATEST_BTPhone1_20231027150155', WebViewer will search the database within the specified time frame for that exact Event ID and display the result.
<br/><br/>Call ID: 5GPOLQATEST
<br/>If user provide the Call ID as '5GPOLQATEST', WebViewer will search the database within the specified time frame and display all the results with the Call ID '5GPOLQATEST'.
<br/><br/>Device ID: BTPhone1
<br/>If user provide the Device ID as 'BTPhone1', WebViewer will search the database within the specified time frame and display all the results with the Device ID 'BTPhone1'.
</p>
  </section>

  <section>
    <h4>Does not Equal:</h4>

    Usage: This feature is used to filter and select values of the Call ID, Device ID, or Event ID that do not match a specified value within a specified time range.<br />
    <br/>Example:
<p style="padding-left:10px;">
Event ID: O_5GPOLQATEST_BTPhone1_20231027150155
<br/>If user provide the Event ID as 'O_5GPOLQATEST_BTPhone1_20231027150155', WebViewer will search the database within the specified time frame for all Event IDs that are not equal to this value and display the results.
<br/><br/>Call ID: 5GPOLQATEST
<br/>If user provide the Call ID as '5GPOLQATEST', WebViewer will search the database within the specified time frame and display all the results with Call IDs that are not equal to '5GPOLQATEST'.
<br/><br/>Device ID: BTPhone1
<br/>If user provide the Device ID as 'BTPhone1', WebViewer will search the database within the specified time frame and display all the results with Device IDs that are not equal to 'BTPhone1'.
</p>
  </section>

  <section>
    <h4>Starts with:</h4>

    Usage: This feature is used to filter and select values of the Event ID that begin with a specified prefix within a specified time range.<br />
    <br/>Example:
<p style="padding-left:10px;">
Event ID: O_5GPOLQATEST_BTPhone1_20231027150155
<br/>If user provide the Event ID as 'O_', WebViewer will search the database within the specified time frame for all Event IDs that start with this prefix and display the results.
</p>
  </section>

  <section>
    <h4>Ends with:</h4>

    Usage: This feature is used to filter and select values of the Event ID that end with a specified suffix within a specified time range.<br />
    <br/>Example:
<p style="padding-left:10px;">
Event ID: O_5GPOLQATEST_BTPhone1_20231027150155
<br/>If user provide the Event ID as '150155', WebViewer will search the database within the specified time frame for all Event IDs that end with this suffix and display the results.
</p>
  </section>

  <section>
    <h4>Contains:</h4>

    Usage: This feature is used to filter and select values of the Event ID that contain a specified substring within a specified time range.<br />
    <br/>Example:
<p style="padding-left:10px;">
Event ID: O_5GPOLQATEST_BTPhone1_20231027150155
<br/>If user provides the Event ID as '20231027', WebViewer will search the database within the specified time frame for all Event IDs that contains '20231027' within their value and display the results.
<br/><br/>Or if user provides part of CallID which is '5G', WebViewer will search the database within the specified time frame for all Event IDs that contains the CallID portion '5G' within their value and display the results.
<br/><br/>Or if user provides part of Device ID which is 'Phone1', WebViewer will search the database within the specified time frame for all Event IDs that contains the Device ID portion 'Phone1' within their value and display the results.
</p>
</section>

  <section>
    <h4>Does not contain:</h4>

    Usage: This feature is used to filter and select values of the Event ID that do not contain a specified substring within a specified time range.<br />
    <br/>Example:
<p style="padding-left:10px;">
Event ID: O_5GPOLQATEST_BTPhone1_20231002123411
<br/>If user provides the Event ID as '20231002', WebViewer will search the database within the specified time frame for all Event IDs that does not contains '20231002' within their value and display the results.
<br/><br/>Or if user provides part of CallID which is 'POLQATEST', WebViewer will search the database within the specified time frame for all Event IDs that does not contains the CallID portion 'POLQATEST' within their value and display the results.
<br/><br/>Or if user provides part of Device ID which is 'BT', WebViewer will search the database within the specified time frame for all Event IDs that does not contains the Device ID portion 'BT' within their value and display the results.
</p>
  </section>
</div>
<br/>
            </body>
          </head>
        </html>
      `)
    popupWindow.document.close();
    // Write the HTML content to the popup window
    //    popupWindow.document.write(`
    //  <html>
    //    <body>
    //      <iframe src="${pdfFilePath}" width="600" height="400"></iframe>      
    //    </body>
    //  </html>
    //`);

    //    // Make sure to close the document write operation
    //    popupWindow.document.close();

  }
}
